const safeNum = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

export const roundMoney = (value) => Number(safeNum(value).toFixed(2));

// Sin default en usdExchangeRate: con `= 0`, un caller que pasa `undefined`
// (p.ej. empresa aún no cargada) lo convertía en 0 y el `??` nunca caía al
// usd_exchange_rate del producto, dejando el precio en sell_price (ARS viejo). Bug P3.
export function getGestionCostosSellPrice(product, usdExchangeRate) {
  const rate = safeNum(usdExchangeRate ?? product?.usd_exchange_rate);
  const priceUsd = safeNum(product?.price_usd);
  // Solo convertimos a ARS si el producto está explícitamente marcado en dólares.
  const pricedInUsd = product?.priced_in_usd === true;

  if (pricedInUsd && priceUsd > 0 && rate > 0) {
    return roundMoney(priceUsd * rate);
  }

  return roundMoney(product?.sell_price);
}
